import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    details: (name: string) => string | React.ReactNode;
    cancel: string;
    remove: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Text for the title of the guest removal confirmation dialog */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GuestRemovalConfirmationDialog.title?c=344pu6qrmpx6u", defaultMessage: "Remove Guest?" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the details of the guest removal confirmation dialog */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "GuestRemovalConfirmationDialog.details?c=132y39emmdmwn", defaultMessage: "Removing {name} from this project will also remove them from the account." }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the button that cancels the guest removal confirmation dialog */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GuestRemovalConfirmationDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the button that removes the guest in the guest removal confirmation dialog */
            remove: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GuestRemovalConfirmationDialog.remove?c=2pgkx9qildj6r", defaultMessage: "Remove" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
